<template lang="html">
  <div class="cw-header" :style="safeAreaInsetStyle">
    <div class="fixed-container navbar is-mobile">
      <div class="navbar-left">
        <slot name="left-items"></slot>
      </div>
      <div class="navbar-center has-text-centered">
        <slot name="content"></slot>
      </div>
      <div class="navbar-right">
        <slot name="right-items"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import safeArea from '@/components/mixins/safe-area';
export default {
  name: 'cw-header',
  mixins: [safeArea],
  components: {},
  props: {},
  data() {
    return {
      safeAreaDefaultInsetValue: '1rem',
    };
  },
  computed: {},
  methods: {},
};
</script>

<style lang="stylus">

$headerPadding = 1rem
$headerZIndex = 100
$headerColor = #231F20
headerDimensions(){
  width: 100%
  // height: 5rem
}
.cw-header {
  headerDimensions()
  padding: 1rem $headerPadding
  width: 100vw
  background: $headerColor
  z-index: $headerZIndex
  position: webkit-sticky
  position: sticky
  top: -1px
}

.cw-header .fixed-container {

  headerDimensions()
  background: $headerColor
  color: white
}

.cw-header h1 {
  margin-bottom: 0
  font-size: 1.4rem
  text-transform: capitalize
}
.cw-header h2 {
  margin-top: 0
  font-size: 1rem
  text-transform: capitalize
}

.navbar {
  display: flex
  align-items: center
  width: 100%
}

.navbar-center {
  flex: 1 1 auto
  margin-left: 2rem
}

.navbar-left, .navbar-right {
  flex: 0 0 3rem
}
.navbar-right {
  text-align: right;
}
.level-right {
  position: fixed
  z-index: $headerZIndex + 1
  right: $headerPadding
}
</style>
